import { useIframe } from '@archipro-website/react-hooks';

import React, { useCallback, useEffect, useState } from 'react';

import type {
    IFrameMessage,
    IFrameMessageDispatcher,
    BusinessManagerMessages,
    Navigate,
    Initialise,
} from '@modules/business-manager/types/business-manager';
import { useDataRefresh } from '@modules/root/hook/use-data-refresh';
import { useNavigate, useMatches } from 'react-router';

const BusinessManagerListener: React.FC = () => {
    const navigate = useNavigate();
    const matches = useMatches();
    const currentPath = matches[matches.length - 1]?.pathname;
    const [initialised, setInitialised] = useState(false);

    const { refresh } = useDataRefresh();

    const handler = useCallback(
        (
            message: IFrameMessage<BusinessManagerMessages>,
            dispatch: IFrameMessageDispatcher<
                IFrameMessage<BusinessManagerMessages>
            >,
        ) => {
            switch (message.type) {
                case 'initialise': {
                    const content = message.content as Initialise;
                    navigate(content.route);
                    setInitialised(true);

                    dispatch({
                        type: 'initialiseDone',
                        content,
                    });
                    break;
                }
                case 'navigate': {
                    const content = message.content as Navigate;
                    navigate(content.route);
                    break;
                }

                case 'refresh': {
                    refresh();
                    dispatch({
                        type: 'refreshDone',
                    });
                    break;
                }
            }
        },
        [refresh, navigate],
    );

    const [dispatch] =
        useIframe<IFrameMessage<BusinessManagerMessages>>(handler);

    useEffect(() => {
        if (!initialised) return;

        dispatch({
            type: 'navigateDone',
            content: {
                route: currentPath ?? '',
            },
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPath]);

    return <></>;
};

export default BusinessManagerListener;
